var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-block"},[_c('about-title',{attrs:{"title":_vm.pageTitle}}),_c('about-content',{attrs:{"content":_vm.pageDescription}}),_c('service-list',{attrs:{"list":_vm.list,"single":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }